import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import queryString from 'query-string'
import styled from 'styled-components'
import { Revisions } from '../../../../../components/TextEditor/revisions'
import PrivatePage, { menuItemObj } from '../../../../../components/PrivatePage'
import Tooltip from '../../../../../components/Tooltip'
// import Loader from '../../../../../components/Loader'
import { get, post } from '../../../../../lib/api'
import GenericError from '../../../../../components/GenericError'
import Loader from '../../../../../components/Loader'
import SaveIcon from '../../../../../components/Images/Save'
import { getAudiobookWordCountLimit } from './helpers'
import { isAdminAccess } from '../../../../../config'
import { Provider } from '../../../../../context/editorContext'
import { BackButton as Back } from '../../../../../components/WithSubHeaderBG'
import History from '../../../../../components/Images/History'
import Undo from '../../../../../components/Images/Undo'
import Redo from '../../../../../components/Images/Redo'
import WordCount from '../../../../../components/Images/WordCount'
import { PrimaryButton, SecondaryButton } from '../../../../../components/Button'
import { Tool, ToolInfo, ToolContainer } from '../../../../../components/TextEditor/styles'
import { TextEditor, getContent, isContentChanged,  isUndoEmpty, isRedoEmpty, handleRedo as onRedo, handleUndo as onUndo} from '../../../../../components/TextEditor'
import Vellip from '../../../../../components/Images/Vellip'
import MobileEditorOptions from './MobileEditorOptions'
import { Box, Text } from '../../../../../designSystem'
import { novelChapterWordCount } from '../../../../../constants'
import AlertSnackBar from '../../../../../components/AlertSnackBar'
import writeIcon from './writing-hand-light-skin-tone.svg'
import { handleNotionOrExternalLink } from '../../../../../lib/utils'
const ControlsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 85%;
  align-items: center;
  background-color:${({ showTitle }) => (showTitle && 'white')};
  @media (max-width: 600px) {
    width: 100%;
  }
`
const LeftDiv = styled.div`
  padding: 8px 0 8px 48px;

  @media (max-width: 600px) {
    padding: 8px 0 8px 0px;
  }
`
const RightDiv = styled.div`
  display: flex;
  justify-content: space-between;
`
const TopDiv = styled.div`
  display: flex;
  align-items: center;
  svg: {
    margin-right: 8px;
  }
`
const BottomDiv = styled.div`
  @media (max-width: 600px) {
    display: none;
  }
`
const TitleInput = styled.input`
  width: 30vw;
  padding: 8px;
  font-size: 16px;
  line-height: 1.3;
  text-align: left;
  color: var(--Text700);
  border-radius: 4px;
  border: ${({ isError }) => isError ? 'solid 1px red' : '2px solid var(--Grey300)'};
  @media (max-width: 600px) {
    width: ${({ isUgcBook }) => isUgcBook ? '120px' : '150px'};
    margin: 8px 0;
    margin-left: 16px;
  }
`
const PrefixInput = styled.input`
  width: 64px;
  padding: 8px;
  font-size: 16px;
  line-height: 1.3;
  text-align: left;
  color: var(--Text700);
  border-radius: 4px;
  border: 2px solid var(--Grey300);
  margin-right: 4px;
`

const BackButton = styled(Back)`
  margin-right: 8px;
`

const GuideRef = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  text-decoration: underline !important;
  gap: 4px;
  cursor: pointer;
  color: blue;
`

const PrefixStr = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: var(--Text500);
  margin-right: 4px;
  font-weight: bold;
`
const ButtonWrapper = styled.div`
  margin-left: 16px;
`
const VellipContainer = styled.div`
  display: flex;
  padding: 8px;
  border-radius: 4px;
  // background-color: #ebecf1;
`

const WriteImg = styled.img`
  width: 24px;
  height: 24px;
  margin-left: 4px;
`

export const EditorControls = ({ isUgcBook, title: titleParam, tab, showTitle = false, chapterCount, action, regex, onBack, onTitleChange, wordCount, undoActive, redoActive, handleUndo, handleRedo, showRevisionsIcon, handleShowRevision, actionButtons: {primary, secondary}={} }) => {
  const [isMobileOptionsShowing, setIsMobileOptionsShowing] = useState(false)
  const [showInputError, setInputError] = useState(false)
  const [titleError, toggleTitleError] = useState(false)
  let title = titleParam
  let prefix = ''
  let prefixStart = ''
  let prefixEnd = ''
  let prefixChapterNumber = ''
  if (regex) {
    const result = titleParam.match(regex)
    if (result) {
      prefix = result[0]
      title = titleParam.replace(regex, '')
      const ResultStrArr = prefix.match(/\s\d+\s/)
      const numberMatchStr = ResultStrArr[0]
      prefixChapterNumber = numberMatchStr.trim()
      const prefixArr = prefix.split(prefixChapterNumber)
      prefixStart = prefixArr[0]
      prefixEnd = prefixArr[1]
    }
  }
  const handleTitleChange = title => {
    onTitleChange(prefix + title)
  }
  const handlePrefixChange = e => {
    const number = e.target.value
    if (!number) return
    const newPrefix = prefixStart + number + prefixEnd
    onTitleChange(newPrefix + title)
  }

  const wordCountSubHeading = (wordCount) => {
    let subHeader = ''
    if(wordCount === 0){
      subHeader = 'start writing!!!'
    }else if(wordCount < novelChapterWordCount){
      subHeader = `minimum ${novelChapterWordCount}`
    }else{
      subHeader = wordCount > 5000 ? 'reduce to 5000' : 'maximum 5000'
    }
    return subHeader
  }

  const handlePrimaryClick = () => {
    if(primary?.label === 'Publish'){
      if(title.toLowerCase() === 'untitled chapter' || title.toLowerCase() === 'chapter title'){
        if (isMobile) document.getElementById('title_mobile').style.border = '1px solid red'
        toggleTitleError(true)
        setInputError(true)
      }else{
        primary.onClick()
      }
    }else{
      primary.onClick()
    }
  }

  const isMobile = window.screen.width < 600
  return (
    <>
      <MobileEditorOptions
        show={isMobileOptionsShowing}
        close={() => setIsMobileOptionsShowing(false)}
        title={titleParam}
        wordCount={wordCount}
        actionButtons={{primary, secondary}}
        showRevisionsIcon={showRevisionsIcon}
        handleShowRevision={handleShowRevision}
      />
      <ControlsDiv showTitle={showTitle}>
        <LeftDiv>
          <TopDiv>
            {!showTitle && <BackButton onClick={onBack} />}
            {!isAdminAccess && (
                <>
                  {!showTitle && <PrefixStr>
                    {action !== 'add-chapter' ? prefix : `Ch ${parseInt(chapterCount) + 1} `}
                  </PrefixStr>}
                  {!isMobile && <>
                    <TitleInput
                      value={title}
                      onChange={e => handleTitleChange(e.target.value)}
                      isError={showInputError}
                      isUgcBook={isUgcBook}
                    />
                    {isUgcBook && <GuideRef 
                        onClick={() => handleNotionOrExternalLink("https://pocketnovel.notion.site/Writing-Tips-468f0ab41d964e3e8553c8129c5aa723")}
                      >
                      <WriteImg src={writeIcon} />Guide
                    </GuideRef>}
                  </>}
                  {showTitle && <>
                    <TitleInput
                      value={title}
                      isUgcBook={isUgcBook}
                      onChange={e => handleTitleChange(e.target.value)}
                      isError={showInputError}
                      id="title_mobile"
                    />
                    {isUgcBook && <GuideRef 
                        onClick={() => handleNotionOrExternalLink("https://pocketnovel.notion.site/Writing-Tips-468f0ab41d964e3e8553c8129c5aa723")}
                      >
                      <WriteImg src={writeIcon} />Guide
                    </GuideRef>}
                  </>}
                </>
              ) 
            }
          </TopDiv>
          <BottomDiv>
            <ToolContainer>
              <Tool>
                <WordCount />
                <ToolInfo>
                  <span className="notranslate">{wordCount}{' '}</span>
                  {wordCount > 1 ? 'words' : 'word'}
                </ToolInfo>
              </Tool>
              {showRevisionsIcon && <Tool onClick={handleShowRevision}>
                <History />
                <ToolInfo>Revisions</ToolInfo>
              </Tool>}
              <Tool
                onClick={handleUndo}
              >
                <Undo
                  fillOpacity={
                    undoActive ? 0.65 : 0.3
                  }
                />
                <ToolInfo
                  style={{
                    color:
                      undoActive
                      ? 'rgba(13, 21, 54, 0.65)'
                      : 'rgba(13, 21, 54, 0.3)'
                  }}
                >
                  Undo
                </ToolInfo>
              </Tool>
              <Tool
                onClick={handleRedo}
              >
                <Redo
                  fillOpacity={
                    redoActive ? 0.65 : 0.3
                  }
                />
                <ToolInfo
                  style={{
                    color:
                      redoActive
                      ? 'rgba(13, 21, 54, 0.65)'
                      : 'rgba(13, 21, 54, 0.3)'
                  }}
                >
                  Redo
                </ToolInfo>
              </Tool>
            </ToolContainer>
          </BottomDiv>
        </LeftDiv>
        <RightDiv>
          {secondary && secondary.show && <Tooltip
            title={
              secondary.tooltip || ''
            }
            arrow
          >
            <SecondaryButton
              active={secondary.enabled}
              onClick={secondary.onClick}
              disabled={!secondary?.enabled}
            >
              {secondary.icon()}
              <span>{secondary.label}</span>
            </SecondaryButton>
          </Tooltip>}

          {primary && primary.show && <ButtonWrapper>
            <Tooltip
              title={
                primary.tooltip || ''
              }
              arrow
            >
              <PrimaryButton
                active={primary.enabled}
                onClick={handlePrimaryClick}
                disabled={!primary?.enabled}
              >
                {!isMobile && primary.icon()}
                <span>{primary.label}</span>
              </PrimaryButton>
            </Tooltip>
          </ButtonWrapper>}
          {isMobile && !showTitle && <VellipContainer><Vellip onClick={() => setIsMobileOptionsShowing(true)} /></VellipContainer>}
          {isMobile && showTitle &&  <Box variant="flex" flexDirection="column" p={8} mr={16}> 
                <Box >
                  <Text variant="heading" fontWeight="normal">{wordCount > 1 ? 'Words ' : 'Word '}<span className='notranslate'>{wordCount}</span></Text>
                </Box>
                <Box>
                  <Text variant="subText" color={wordCount === 0 ? '' : (wordCount < novelChapterWordCount || wordCount > 5000) ? "var(--crimson-500)" : "var(--lime-500)" }>{wordCountSubHeading(wordCount)}</Text>
                </Box>
              </Box>}
        </RightDiv>
        {titleError && <AlertSnackBar 
            closeBtn={true} 
            text={'Kindly Update Your Chapter Title'} 
            close={() => toggleTitleError(false)}
        />}
      </ControlsDiv>    
    </>
  )
}

const AddEditChapter = (props) => {
  const {
    history,
    match: {
      params: { id },
    },
    location: { search }
  } = props
  const qParams = queryString.parse(search)
  const { chapter_id, title: titleFromQpram, create_new, language, book_type } = qParams
  const [content, setContent] = useState('')
  const [wordCount, setWordCount] = useState(0)
  const [editorState, setEditorState] = useState(null)
  const [title, setTitle] = useState(titleFromQpram || '')
  const [isLoading, setLoading] = useState(false)
  const [apiError, toggleApiError] = useState(false)
  const [showPreview, toggleShowPreview] = useState(false)
  const [showVersion, toggleShowVersion] = useState(false)

  useEffect(() => {
    if (create_new === 'true') return
    if (!chapter_id) return
    setLoading(true)
    get('/content_api/book.get_chapter_details', {
      params: {
        chapter_id,
        book_id: id,
        view: isAdminAccess ? 'cms' : 'dashboard',
        is_novel: 1
      }
    }).then(response => {
      const { result } = response
      const { file_url, chapter_title } = result
      if (!title) setTitle(chapter_title)
      if (file_url) {
        Axios.get(file_url).then(response => {
          setContent(response.data)
        })
      } else {
        setLoading(false)
      }
    })
  }, [])

  useEffect(() => {
    if (title && content) setLoading(false)
  }, [title, content])

  const createPreview = (content) => {
    return {
      __html: content,
    }
  }

  const updateState = (editor) => {
    setEditorState(editor)
  }

  const updateTitle = title => {
    setTitle(title)
  }

  const updateWordCount = count => {
    setWordCount(count)
  }

  const handleChapterSave = () => {
    const isValid = isContentChanged(editorState) && wordCount >= getAudiobookWordCountLimit(language, book_type)
    if (!isValid) return

    const content = getContent(editorState)

    setLoading(true)
    //create a text file
    const file = new Blob([content], {
      type: 'text/plain;charset=utf-8',
    })

    let url = ''

    // upload to s3
    const params = {
      title,
      tags: 'file',
      file_dir: id,
      image_extension: 'txt',
      is_novel: 1
    }
    const getPreSignedUrl = '/upload/get_presigned_url'
    get(getPreSignedUrl, { params }).then((response) => {
      const imageUrl = response.result[0]
      const awsFields = imageUrl.fields
      const prefix = imageUrl.url
      const suffix = imageUrl.s3_unique_key
      const formData = new FormData()
      formData.append('key', awsFields.key)
      formData.append('AWSAccessKeyId', awsFields.AWSAccessKeyId)
      formData.append('x-amz-security-token', awsFields['x-amz-security-token'])
      formData.append('policy', awsFields.policy)
      formData.append('signature', awsFields.signature)
      formData.append('file', file)
      const cdn = 'https://d31b0xt3oaqqjh.cloudfront.net'
      post(prefix, { data: formData })
        .then((response) => {
          url = `${cdn}/${id}/${suffix}`

          if (chapter_id) {
            const dataForVersion = {
              chapter_id,
              word_count: wordCount,
              file_url: url,
              chapter_title: title,
              book_id: id,
              // status: 'pending',
              view: isAdminAccess ? 'cms' : 'dashboard',
            }
            return post('/content_api/book.version?is_novel=1', {
              data: dataForVersion
            }).then(() => {
              history.push(`${menuItemObj.audiobooks}/edit/${id}`)
            })

          } else {
            const dataForChapter = {
              book_id: id,
              chapter_title: title,
              file_url: url,
              word_count: wordCount,
              view: 'writers',
            }

            return post('/content_api/book.create_chapter?is_novel=1', {
              data: dataForChapter
            }).then(() => {
              history.push(`${menuItemObj.audiobooks}/edit/${id}`)
            })
          }
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  // convert the child - Fragment of privatePage to a different component in order to receive props passed by it
  // in future if it it intented to use the received props
  return (
    <Provider value={() => (
      <EditorControls
          title={title}
          onBack={() => history.goBack()}
          onTitleChange={setTitle}
          wordCount={wordCount}
          undoActive={!isUndoEmpty(editorState)}
          redoActive={!isRedoEmpty(editorState)}
          handleUndo={() => onUndo(editorState, setEditorState)}
          handleRedo={() => onRedo(editorState, setEditorState)}
          handleShowRevision={() => toggleShowVersion(true)}
          showRevisionsIcon={chapter_id}
          actionButtons={{
            secondary: {
              label: 'Save',
              tooltip: wordCount < getAudiobookWordCountLimit(language, book_type) ? `Please type atleast ${getAudiobookWordCountLimit(language, book_type)} words to continue` : !isContentChanged(editorState) ? 'Please make some changes first' : '',
              icon: SaveIcon,
              show: true,
              enabled: isContentChanged(editorState) && wordCount >= getAudiobookWordCountLimit(language, book_type),
              onClick: handleChapterSave
            }
          }}
        />
      )
      }
    >
      <PrivatePage isProfileNameShown={false}>
        <>
          {isLoading && !apiError && <Loader />}
          {!isLoading && apiError && <GenericError
            show={apiError}
            onClose={() => toggleApiError(false)}
          />}
          {!isLoading && <TextEditor
            content={content}
            editorState={editorState}
            updateState={updateState}
            updateWordCount={updateWordCount}
          />}
          {!isLoading && showVersion && <Revisions open={showVersion} close={() => toggleShowVersion(false)} chapter_id={chapter_id} />}
          {/* <Preview
            open={showPreview}
            close={() => toggleShowPreview(false)}
            title={title}
            content={content}
          /> */}
        </>
      </PrivatePage>
    </Provider>
  )
}

export default AddEditChapter
